import { useCallback } from 'react';

type Impact = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
type Notification = 'success' | 'warning' | 'error';

export function useHaptic() {
  const impact = useCallback((style: Impact = 'light') => {
    try {
      window.Telegram?.WebApp?.HapticFeedback?.impactOccurred?.(style);
    } catch {
      /* ignore */
    }
  }, []);
  const selection = useCallback(() => {
    try {
      window.Telegram?.WebApp?.HapticFeedback?.selectionChanged?.();
    } catch {
      /* ignore */
    }
  }, []);
  const notify = useCallback((kind: Notification) => {
    try {
      window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred?.(kind);
    } catch {
      /* ignore */
    }
  }, []);
  return { impact, selection, notify };
}
